<script setup>
import { ref } from 'vue';
import { useForm, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import { __, isNumber, requestPostNewLead } from '@/utils';
import Loader from '@components/loader.vue';

const loading = ref(false);
const error = ref(false);

const currentSchema = yup.object().shape({
	name: yup.string().required(__('Required field')),
	phone: yup.string().required(__('Required field')),
});

const { handleSubmit, meta } = useForm({
	validationSchema: currentSchema,
	keepValuesOnUnmount: true,
});

const onSubmit = handleSubmit(async (values) => {
	loading.value = true;

    const payload = JSON.stringify(values);
	const [data] = await requestPostNewLead(payload);
	const dataJSON = JSON.parse(data.data);

	if(!dataJSON.response.status) {
		error.value = true;
	}
	
	loading.value = false
});
</script>

<template>
	<div>
		<p v-if="error">{{ __('A fault has occurred. Please try again.') }}</p>
		<form @submit="onSubmit" v-if="!error">
			<Field type="hidden" name="plan_id" value="" />
			<div class="field-row">
				<div class="field">
					<div>
						<ErrorMessage name="name" as="span" class="field__error" />
						<label for="name"><strong>{{ __('full name') }}</strong></label>
						<Field type="text" name="name" />
					</div>
				</div>
				<div class="field">
					<div>
						<ErrorMessage name="phone" as="span" class="field__error" />
						<label for="phone"><strong>{{ __('phone') }}</strong></label>
						<Field type="text" @keypress="isNumber($event)" maxlength="11" name="phone" />
					</div>
				</div>
			</div>
			<button type="submit" :disabled="!meta.valid || loading" class="btn js-btn">{{ __('Send') }} <Loader class="align-end combobox-loader" color="#fff" v-if="loading" /></button>
		</form>
	</div>
</template>